import React, { useEffect } from 'react'

import {useDispatch, useSelector} from 'react-redux'
import {logoutUser} from '../Redux/loginUserSlice'
import Header from './Header'
import { fetchFoods, showFood } from '../Redux/foodSlice'
import { foodList } from '../Data'
import ShowFoods from './ShowFoods'
import Footer from './Footer'

const Home = () => {
const dispatch = useDispatch()
const BASE_URl = window.location.origin

useEffect(()=>{
  fetch(`${BASE_URl}/api/verifyLogin`, {
    method: 'GET',
    credentials: 'include'
  }).then((res) => res.json())
  .then((data) => {
    if(data.sucess === false) {
      dispatch(logoutUser())
    }
  }).catch((error) => {
    console.log(error)
  })
},[dispatch, BASE_URl])

useEffect(()=>{
  dispatch(fetchFoods())
},[dispatch])

const {showItems, category} = useSelector((state) => state.food)

const handleShowFood = (foodName) => {
  dispatch(showFood(foodName))
}




  return (
    <>
    <div className='mt-14'>
      <Header/>
    </div>
    <div>
    <h1 className='font-bold text-xl font-mono ml-9 mt-10 pr-9 pl-9 sm:text-3xl'>Choose Your Choice</h1>
    </div>
    <div className='flex justify-center'>
    <ul className='h-42 flex overflow-scroll mt-12' style={{scrollbarWidth: 'none', scrollBehavior: 'smooth'}}>
      {foodList.map((item, i) => {
        return (
          <li key={i} className='h-[140px] w-[140px] mr-14 ml-6 felx felx-col justify-evenly items-center rounded-full cursor-pointer lg:gap-11' 
          onClick={()=>{handleShowFood(item.foodName)}}
          >
            <div className='w-22 h-22'>
          <img src={item.icon} alt='items' style={item.foodName === category?{border: '3px solid black'}:null} className='w-[100%] h-[100%] object-cover rounded-full shadow-2xl'/>
            </div>
            <p className='font-bold text-[12px] mt-3 text-center'>{item.foodName}</p>
          </li>
        )
      })}
    </ul>

    
    </div>
    <ShowFoods
    showItems={showItems}
    category = {category}
    />

    <Footer/>
    </>
  )
}

export default Home
